export default class UpdateTaskAssignee {
  constructor(context) {
    this.context = context;
  }

  run({ assignee, conversationItemId, location }) {
    let store = this.context.stores.conversationHistory;
    let taskItem = store.find(conversationItemId);
    taskItem.content.assign(assignee);
    store.replace(taskItem);

    let conversationItemUpdate = {
      content: {
        assignee: taskItem.content.assignee.toJs(),
      },
    };

    this.context.gateways.task.update(this.currentAgent.id, taskItem.id, {
      id: conversationItemId,
      customerId: this.currentCustomerId,
      conversationItem: conversationItemUpdate,
    });

    this.context.analytics.track('Task Assignee Changed', {
      agentId: assignee.agentId,
      routingGroupId: assignee.routingGroupId,
      itemId: conversationItemId,
      location,
    });
  }

  get currentAgent() {
    return this.context.stores.currentAgent.get();
  }

  get currentCustomerId() {
    return this.context.stores.currentLocation.get().customerId;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation_item/task/update_task_assignee.js